import {
  scattered_media_default
} from "./chunk-GJ7YXWOE.js";

// src/layouts/scattered-media/index.ts
var scattered_media_default2 = scattered_media_default;

export {
  scattered_media_default2 as scattered_media_default
};
